<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
		<div class="search">
			<el-input v-model="jgmc" placeholder="机构、机构id、负责人、手机号" clearable style="width: 290px;margin-bottom: 10px;"></el-input>
			<el-button @click="findJgglList" style="margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
		</div>
    <el-row style="height: 330px;overflow-y: auto">
      <el-col :span="8" style="margin-bottom: 10px" v-for="(item, index) in jgglList" :key="item.id" @click.native="selectJggl(item)">
        <el-card :body-style="{ padding: '0px' }" :class="item.isSelect?'box-card card-select':'box-card'">
          <div slot="header" class="clearfix" style="position: relative;height: 15px">
            <span style="color: #18CE58;position: absolute;left: 2px" v-if="item.isSelect" class="el-icon-success"></span>
            <span style="position: absolute;left: 25px;top: -3px;">{{ item.jgmc }}</span>
          </div>
          <div class="item-content">
            <div class="text item"><label>机构编码：</label>{{item.jgbm}}</div>
            <div class="text item"><label>负责人：</label>{{item.fzr}}</div>
            <div class="text item"><label>手机号：</label>{{item.sjh}}</div>
            <div class="text item" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="item.dz"><label>地址：</label>{{item.dz}}</div>
            <div class="text item"><label>账户余额积分：</label>
              <span v-if="item.ywList && item.ywList.length">
                <span v-for="(yw, index) in item.ywList" :key="index">
                  {{ yw.ywmc || getYwName(yw.ywcode) }}：{{ yw.zhyejf }}<i v-if="index!=item.ywList.length-1">，</i>
                </span>
              </span>
            </div>
            <img v-if="item.zhzt==1" src="../../../assets/img/02yiqiyong.png" height="45" width="63" style="position: absolute;right: 25px;bottom: 30px;" alt=""/>
<!--            <div class="text item">
              <label>账户状态：</label>
              <span v-if="item.zhzt==0">已禁用</span>
              <span v-if="item.zhzt==1">启用中</span>
            </div>-->
          </div>
        </el-card>
      </el-col>
      <div style="text-align:center;margin: auto;" v-if="jgglList.length == 0">
        <el-empty description="暂无机构,请查询......"></el-empty>
      </div>
    </el-row>
    <el-row style="margin-top: 10px;border-top: #CCCCCC 1px solid;">
      <el-form ref="form" label-width="160px" label-position="right" style="margin-top: 10px;padding-left: 35%">
        <el-form-item label="业务：">
          <el-select v-model="ywcode" placeholder="请选择业务" clearable style="width: 200px;margin-bottom: 10px;">
            <el-option v-for="item in jgYwList" :key="item.ywcode" :label="item.ywmc || item.ywcode" :value="item.ywcode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退积分：">
          <el-input v-model="tjf" @input="value => numberInputHandler(value, 'tjf', this)" min="0" type="Number" placeholder="退积分" clearable style="width: 200px;margin-bottom: 10px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="jgglTjfSave">确认退积分</el-button>
        </el-form-item>
      </el-form>
    </el-row>
	</div>
</template>

<script>
export default {
	name: 'dlsjgTjf',
	data() {
		return {
			userType: sessionStorage.getItem("userType"),
			dlsglId: sessionStorage.getItem("dlsglId"), // 代理商id
      jgmc: '',//机构名称
      curDate: new Date().getTime(),
      jgglList: [],
			jgId: '',
			loading: false,
      tjf: 0,
      isSelect: false,
      selectJg: {},
      ywList: [], // 所有业务列表（用于显示账户余额积分中的业务名称）
      jgYwList: [], // 选中机构的业务列表（用于业务选择下拉框）
      ywcode: '' // 选中的业务code
		}
	},
  components:{},
	created() {
		this.sltData();
	},
	methods: {
    // 根据业务ID获取业务名称
    getYwName(ywcode) {
      const yw = this.ywList.find(item => item.ywcode === ywcode);
      return yw ? yw.ywmc : '';
    },
    // 下拉列表数据
    sltData() {
      // 业务列表
      this.$post("admin/YwController/list", { zt: 1 }).then(rep => {
        if (rep.code == 1) {
          this.ywList = rep.result.list;
        }
      })
    },
    // 获取数据
    findJgglList() {
      var _this = this;
      var params = {
        dlsglId: _this.dlsglId,
        jgmc: _this.jgmc,
        zhzt: 1
      }
      _this.loading = true;
      _this.$post("jggl/JgglController/jgglList", params).then(async rep => {
        _this.loading = false;
        if (rep.code == 1) {
          // 使用map创建新对象确保响应式
          _this.jgglList = rep.result.jgglList.map(item => ({
            ...item,
            isSelect: false
          }));
          _this.selectJggl(_this.selectJg);
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    // 选择机构（实现严格单选）
    selectJggl(item){
      this.selectJg = item;
      // 先记录当前选中状态
      const wasSelected = item.isSelect;

      // 创建新数组确保响应式更新
      const newList = this.jgglList.map(item2 => {
        return {
          ...item2,
          isSelect: item2.id === item.id ? !wasSelected : false
        };
      });
      this.jgglList = newList;

      // 同步更新选中ID（如果取消选中则清空）
      this.jgId = wasSelected ? '' : item.id;

      // 更新业务列表为选中机构的ywList
      if (!wasSelected && item.ywList) {
        this.jgYwList = item.ywList;
      } else {
        this.jgYwList = [];
      }
      this.ywcode = ''; // 重置选中的业务
    },
    jgglTjfSave(){
      var _this = this;
      if(!_this.jgId){
        _this.$message({
          type: "error",
          message: '请选择机构'
        });
        return;
      }
      if(!_this.ywcode){
        _this.$message({
          type: "error",
          message: '请选择业务'
        });
        return;
      }
      if(!_this.tjf){
        _this.$message({
          type: "error",
          message: '请输入退积分'
        });
        return;
      }else{
        if(_this.tjf<=0){
          _this.$message({
            type: "error",
            message: '退积分不能小于等于0'
          });
          return;
        }
      }
      _this.$confirm('是否确认退积分', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {
          jgglId: _this.jgId,
          tjf: _this.tjf,
          tjfsj: _this.curDate,
          ywcode: _this.ywcode
        }
        this.$post("jggl/JgglController/jgglTjfSave", params,'json').then(rep => {
          if (rep.code == '1') {
            this.$message({
              type: "success",
              message: '退积分成功'
            });
            this.findJgglList();
            //this.jgId='';
            this.tjf='';
            this.ywcode='';
            this.jgYwList=[];
          } else {
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      })
    }
	},
}
</script>

<style lang="less">
.school-manage {
	.search {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 10px;
		.el-select,
		.el-input {
			margin-right: 10px;
		}
	}
  .item-content{
    position: relative;
    padding: 10px 20px 10px;
  }
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 8px;
    label{
      width: 100px;
      display: inline-block;
      text-align: right;
      color: #333333;
      font-weight: 400;
    }
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    cursor: pointer;
    width: 98%;
    height: 185px;
    .el-card__header{
      padding: 10px 10px;
      background: #ECECEC;
    }
  }
  .card-select{
    border: 1px solid #18CE58;
  }
}
</style>
